/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import { baseUrl } from "./endpoints.js";
import { configReq } from "../lib/functions.js";
import { logout } from "../state/slices/user.js";
import axiosInstance from "./axiosInstance.js";
import { buildTableQuery } from "./query-params";
import { readStoredId } from "../state/storage";

const identityResponse = (payload) => payload;

const DataFetcher = (
  limit,
  page,
  sort,
  url,
  filter,
  filterTypeIsArray = false,
  refreshData,
  sumbitSearch,
  viewType = 1,
  moreFilter = false,
  adaptResponse = identityResponse,
  requestPage = axiosInstance,
  paginationMode
) => {
  const [loading, setLoading] = useState(true);
  const [errors, setError] = useState(false);
  const [allData, setData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const dispatch = useDispatch();
  const [header, setHeaders] = useState([]);
  const [setting, setSettings] = useState({});
  const replaceRows = useRef(true);
  const { token } = useSelector((state) => state.user);
  const appendPages = paginationMode ? paginationMode === "infinite" : viewType === 1 && readStoredId("pageType") === 1;
  useEffect(() => {
    replaceRows.current = true;
  }, [sort, filter, refreshData, sumbitSearch, limit, url, token]);
  useEffect(() => {
    setLoading(true);
    setError(false);
    let cancel;
    let active = true;
    const query = buildTableQuery({ page, limit, sort, search: sumbitSearch,
      filter: filterTypeIsArray ? filter : [], extra: moreFilter });
    requestPage(`${baseUrl}/${url}?${query}`, {
      ...configReq(token),
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((response) => {
        if (!active) return;
        const res = { ...response, data: adaptResponse(response.data, { page, limit }) };
        const replace = replaceRows.current;
        replaceRows.current = false;
        setData((prev) => {
          if (replace || !appendPages || page === 1) return res.data.data;
          const rows = [...prev];
          for (const row of res.data.data) {
            const index = row.id == null ? -1 : rows.findIndex((old) => old.id === row.id);
            if (index < 0) rows.push(row); else rows[index] = row;
          }
          return rows;
        });
        setMetaData(res.data.meta);
        setHeaders(res.data.header);
        setSettings(res.data.setting);
        setCurrentPage(page);
        setHasMore(res.data.meta.total_pages > page);
        setLoading(false);
      })
      .catch((e) => {
        if (!active || axios.isCancel(e)) return;
        toast.error(e.response?.data?.message || e.message || "دریافت اطلاعات انجام نشد.");
        if (e.response?.status === 401 || e.response?.status === 403) {
          dispatch(logout());
        }
        setLoading(false);
        setError(true);
        if (!appendPages || page === 1) {
          setData([]); setMetaData(null); setCurrentPage(null);
        }
        setHasMore(false);
      });
    return () => { active = false; cancel?.(); };
  }, [
    dispatch,
    filter,
    page,
    sort,
    token,
    url,
    refreshData,
    sumbitSearch,
    limit,
    appendPages,
    moreFilter,
    adaptResponse,
    requestPage,
    filterTypeIsArray,
  ]);
  return {
    hasMore,
    loading,
    errors,
    allData,
    CurrentPage,
    metaData,
    header,
    setting,
  };
};

export default DataFetcher;
